import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid ${colors.gallery};

  img {
    max-height: ${({ paymentPage }) => (paymentPage ? '3rem' : '3.5rem')};
  }

  @media (min-width: ${breakpoints.desktop}) {
    border: 1px solid ${colors.gallery};
  }

  @media (max-width: ${breakpoints.medium}) {
    position: sticky;
    top: 0;
    background: ${colors.white};
    z-index: 9;
  }
`;

export const Heading = styled.div`
  font-size: 32px;
  font-weight: 590;
  text-transform: uppercase;

  padding: ${({ missingLogo }) => missingLogo && '1rem 0'};
`;

export const PaymentAmount = styled.div`
  font-size: 30px;
  font-weight: 590;
`;
